import { useState, useCallback } from 'react';
import { GridCellModes } from '@mui/x-data-grid';

export function useSingleClickEdit() {
    const [cellModesModel, setCellModesModel] = useState({});

    const handleCellClick = useCallback((params, event) => {
        if (!params.isEditable) return;

        // Ignorar clicks en portales o elementos flotantes
        if (
            event.target instanceof Node &&
            !event.currentTarget.contains(event.target)
        )
            return;

        setCellModesModel((prevModel) => {
            const newModel = {};

            // Poner todas las otras celdas en modo View
            Object.keys(prevModel).forEach((id) => {
                newModel[id] = {};
                Object.keys(prevModel[id]).forEach((field) => {
                    newModel[id][field] = { mode: GridCellModes.View };
                });
            });

            // Activar edición en la celda actual
            newModel[params.id] = {
                ...(newModel[params.id] || {}),
                [params.field]: { mode: GridCellModes.Edit },
            };

            return newModel;
        });
    }, []);

    const handleCellModesModelChange = useCallback((newModel) => {
        setCellModesModel(newModel);
    }, []);

    return {
        cellModesModel,
        handleCellClick,
        handleCellModesModelChange,
    };
}
